import React from 'react';
import { Plug, Search, ArrowRight } from 'lucide-react';
import { Card } from '@shared/ui/card';
import { GuestPortalTopnav } from '../../Topnav';
import { AnnouncementBanner } from '../../AnnouncementBanner';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NSCLanding() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
           <div className="h-screen flex flex-col bg-[#f8f9fa] overflow-hidden">
              <GuestPortalTopnav />
              
              {/* Banner */}
              <AnnouncementBanner />
              <div className="flex-1 overflow-y-auto">
                <div className="min-h-full flex flex-col items-center justify-center p-6 relative">
                  <div className="w-full max-w-4xl mx-auto flex flex-col items-center">
        
        {/* Header Section */}
        <div className="flex flex-col items-center text-center mb-12">
          <div className="w-[68px] h-[68px] bg-[#1e5eff] rounded-[20px] flex items-center justify-center mb-6 shadow-sm">
            <Plug className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-[28px] font-extrabold text-[#0f172a] mb-3 tracking-tight">
            {t("Utility Connection Services")}
          </h1>
          <p className="text-[15px] text-slate-500 max-w-md leading-relaxed font-medium">
            {t("Apply for a new utility connection or track the status of an existing application.")}
          </p>
        </div>

        {/* Cards Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-3xl">
          
          {/* Card 1 */}
          <Card 
            onClick={() => navigate('/guest/nsc-create')}
            className="p-8 border-2 border-slate-100 rounded-[24px] hover:border-[#1e5eff]/20 hover:shadow-lg transition-all duration-300 cursor-pointer group bg-white"
          >
            <div className="w-12 h-12 bg-[#e0e7ff] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-105 transition-transform duration-300">
              <Plug className="w-5 h-5 text-[#1e5eff]" />
            </div>
            <h2 className="text-[17px] font-bold text-slate-900 mb-3">
              {t("Request New Connection")}
            </h2>
            <p className="text-[14px] text-slate-500 mb-8 leading-relaxed font-medium">
              {t("Apply online for a new water, sewer, or trash utility connection at your property.")}
            </p>
            <div className="flex items-center gap-2 text-[14px] font-bold text-[#1e5eff] group-hover:translate-x-1 transition-transform duration-300">
              {t("Start Application")} <ArrowRight className="w-4 h-4" />
            </div>
          </Card>

          {/* Card 2 */}
          <Card 
            onClick={() => navigate('/guest/application-status')}
            className="p-8 border-2 border-teal-200 rounded-[24px] hover:shadow-lg transition-all duration-300 cursor-pointer group bg-white"
          >
            <div className="w-12 h-12 bg-teal-100/60 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-105 transition-transform duration-300">
              <Search className="w-5 h-5 text-teal-500" />
            </div>
            <h2 className="text-[17px] font-bold text-slate-900 mb-3">
              {t("Check Application Status")}
            </h2>
            <p className="text-[14px] text-slate-500 mb-8 leading-relaxed font-medium">
              {t("Track the progress of your existing connection application using your application ID or phone number.")}
            </p>
            <div className="flex items-center gap-2 text-[14px] font-bold text-teal-600 group-hover:translate-x-1 transition-transform duration-300">
              {t("Track Status")} <ArrowRight className="w-4 h-4" />
            </div>
          </Card>
          
        </div>

      </div>
        </div>
      </div>
    </div>
  );
}

export const Landing = NSCLanding;
